import { Model, ModelAttributes, model, modelConfig, reference } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import AccountUser from "./AccountUser";
import Club from "./Club";
import FundingAppeal from "./FundingAppeal";
import { Database } from "./database.types";

const config = modelConfig(
  {
    access_token: {
      type: "string",
    },
    account_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    created_by_account_user_id: {
      type: "string",
    },
    directory_ai_reason: {
      type: "string",
    },
    directory_moderation_status: {
      type: "enum",
      enumType: "" as Database["public"]["Enums"]["funding_appeal_landing_page_directory_moderation_status"],
    },
    draft_html: {
      type: "string",
    },
    finished_template_config: {
      type: "json",
      jsonType: {} as Record<string, unknown>,
    },
    funding_appeal_id: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    landing_enabled: {
      type: "boolean",
    },
    name: {
      type: "string",
    },
    published_at: {
      type: "datetime",
    },
    slug: {
      type: "string",
    },
    submitted_at: {
      type: "datetime",
    },
    submitted_html: {
      type: "string",
    },
    success_draft_html: {
      type: "string",
    },
    success_enabled: {
      type: "boolean",
    },
    success_submitted_html: {
      type: "string",
    },
    template_config: {
      type: "json",
      jsonType: {} as Record<string, unknown>,
    },
    updated_at: {
      type: "datetime",
    },
    visibility: {
      type: "enum",
      enumType: "unlisted" as Database["public"]["Enums"]["funding_appeal_landing_page_visibility"],
    },
  },
  {},
  {
    account: reference(() => Account as any, "account_id"),
    club: reference(() => Club as any, "club_id"),
    created_by_account_user: reference(() => AccountUser as any, "created_by_account_user_id"),
    funding_appeal: reference(() => FundingAppeal as any, "funding_appeal_id"),
  },
);

interface FundingAppealLandingPage extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_appeal_landing_pages", config)
class FundingAppealLandingPage extends Model<typeof config> {}

export default FundingAppealLandingPage;
